import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import Button from "../../Components/Button";
import axios, { AxiosResponse } from "axios";
import moment from "moment";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
declare var c4kCore: any;
declare function fbq(event: string, action: string, data?: object): void;

interface IParentEnquiryProps {
    [key: string]: any;
}

interface IEnquiryResponse {
    isSuccess: boolean;
    errors?: string[];
    enquiryIds?: { [key: string]: string };
}

interface IAxiosResponse {
    data: IEnquiryResponse;
}

const getAllIdsFromCookies = (): string[] => {
    const cookies = document.cookie.split("; ");
    const ids: string[] = [];

    cookies.forEach((cookie) => {
        if (cookie.startsWith("brandedHash_")) {
            const id = cookie.split("=")[0].split("_")[1]; // Extract ID from cookie name
            ids.push(id);
        }
    });

    return ids;
};

const careDays = ["Mon", "Tue", "Wed", "Thu", "Fri"];

let daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
function Review(props: IParentEnquiryProps) {
    const [errorMessage, setErrorMessage] = useState("");
    const {
        startEnquiry,
        childDetail,
        parentDetail,
        maximiseOptions,
        pickerTimePersonTour,
        chooseTime,
    } = props.enquiryDetail;
    const [isLoading, setIsLoading] = useState(false);

    const centreUserIdHash = [
        ...maximiseOptions.map((item) => item.centreUserIdHash),
        props.centreUserIdHash,
    ].join(",");
    const [dayName, setDayName] = React.useState("");
    const { executeRecaptcha } = useGoogleReCaptcha();

    useEffect(() => {
        let date = new Date(pickerTimePersonTour?.liveTourAvailData?.slot);
        let day = date.getDay();
        setDayName(daysOfWeek[day]);
        props.sendEventGa4({
            eventName: "enquiry_workflow",
            FormStep: "review",
            Action: "start",
            ListingType: props.listingType,
        });
    }, []);
    function getUTMParamsFromCookie() {
        const cookies = document.cookie.split("; ").reduce((acc, cookieStr) => {
            const [key, value] = cookieStr.split("=");
            acc[key] = decodeURIComponent(value);
            return acc;
        }, {});

        const utmKeys = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_source_platform",
        ];

        const result = {};
        utmKeys.forEach((key) => {
            if (cookies[key]) {
                result[key] = cookies[key];
            }
        });

        return result;
    }

    const utmMap = {
        utm_source: "utmSource",
        utm_medium: "utmMedium",
        utm_campaign: "utmCampaign",
        utm_source_platform: "utmSourcePlatform",
    };

    const utms = getUTMParamsFromCookie();

    const handleSendEnquiry = async () => {
        setIsLoading(true);
        if (!executeRecaptcha) {
            setErrorMessage("reCAPTCHA not available yet");

            props.sendEventGa4({
                eventName: "enquiry_workflow_feature",
                FeatureName: "submit error",
                FeatureData: `no token`,
            });
            setIsLoading(false);
            return;
        }

        try {
            const token = await executeRecaptcha("api_call");
            if (!token) {
                setErrorMessage("Failed to verify reCAPTCHA. Please try again.");

                props.sendEventGa4({
                    eventName: "enquiry_workflow_feature",
                    FeatureName: "submit error",
                    FeatureData: `no token`,
                });
                setIsLoading(false);
                return;
            }

            let payload = enrichForEnquirySave(token);
            let headers = {
                "Content-Type": "application/json",
            };

            const json = JSON.stringify(payload);
            const { data: responseData } = await axios.post<
                any,
                AxiosResponse<IEnquiryResponse>
            >(props.data.enquiryRequestUrl, json, { headers: headers });

            if (responseData.isSuccess) {
                if (typeof fbq === "function") {
                    fbq("track", "Lead");
                }

                let enquiryId: string[] = [];
                if (responseData?.enquiryIds != null) {
                    Object.keys(responseData.enquiryIds).forEach((id) => {
                        if (responseData.enquiryIds) {
                            enquiryId.push(responseData.enquiryIds[id]);
                        }
                    });
                }
                props.setSendGa4Register();
                props.setEnquiryID(enquiryId);
                setIsLoading(false);
                c4kCore.optimizelyT3SubmitEnquiry()
                props.sendNewEventGa4RoiEnquiryCurrentCentre();
                if (props.isBasic && maximiseOptions.length >= 0) {
                    maximiseOptions.forEach((element) => {
                        props.sendNewEventGa4RoiEnquiryUpsellCenter({
                            centreUserIdHash: element.centreUserIdHash,
                            centreGroupId: element.centreGroupId,
                            listingType: element.listingType,
                            suburb: element.suburb,
                            postcode: element.postcode,
                            state: element.state,
                        });
                        c4kCore.optimizelyT3SubmitEnquiry()
                    });
                }

                props.sendEventGa4({
                    eventName: "enquiry_workflow",
                    FormStep: "review",
                    Action: "finish",
                    ListingType: props.listingType,
                });
                props.onNext({
                    data: null,
                });
            } else {
                setIsLoading(false);
                setErrorMessage(
                    responseData?.errors?.[0] ||
                    "Failed to submit enquiry. Please try again."
                );

                if (responseData.errors[0] === "reCaptcha failed") {
                    props.sendEventGa4({
                        eventName: "enquiry_workflow_feature",
                        FeatureName: "submit error",
                        FeatureData: `invalid token`,
                    });
                    return;
                }
            }
        } catch (error) {
            setIsLoading(false);
            setErrorMessage(error);
            if (axios.isAxiosError(error)) {
                props.sendEventGa4({
                    eventName: "enquiry_workflow_feature",
                    FeatureName: "submit error",
                    FeatureData: `${error.response?.status}`,
                });
            }
        }
    };

    function calculateAge(dob: string): string {
        // Split the input string into day, month, and year
        const [day, month, year] = dob.split("/").map(Number);

        // Create a valid Date object with (YYYY, MM-1, DD) format
        const birthDate = new Date(year, month - 1, day);

        if (isNaN(birthDate.getTime())) {
            return "Invalid date format"; // Handle invalid dates
        }

        const today = new Date();

        // Calculate age
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        // Adjust age if the birthday hasn't occurred this year yet
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }

        return `${age} years old`;
    }

    const hasVisitedBrandedHub =
        (getAllIdsFromCookies().includes("g8") && props.data.centreGroupId === 1) ||
        getAllIdsFromCookies().includes(props.data.centreBrandHashId);

    const enrichForEnquirySave = (token: string) => {
        let additionalQuestionsPayload: number[] = [];
        let enquiryType = 1;
        startEnquiry.map((x) => {
            if (x.label == "Request a tour") {
                enquiryType = x.id;
            }
            if (x.label == "Fees") {
                additionalQuestionsPayload.push(0);
            }
            if (x.label == "Availability") {
                additionalQuestionsPayload.push(1);
            }
            if (x.label == "Programs") {
                additionalQuestionsPayload.push(2);
            }
        });

        const updatedChildrenDetails = childDetail.items.map((child) => ({
            careStartDate: new Date(child.startDate.startDate)
                ?.toISOString()
                .split("T")[0],
            overnightCareRequired:
                child.careDays.find((item) => item.value == "9") > 0,
            name: child.childName,
            birthday: `${child.year}-${child.month < 10 ? "0" : ""}${parseInt(
                child.month,
                10
            ).toString()}-${child.day < 10 ? "0" : ""}${parseInt(
                child.day,
                10
            ).toString()}`,
            selectedCareDays: child.careDays
                .map((item) => Number(item.value))
                .sort((a, b) => a - b),
        }));

        return {
            enquiryType: props.isPickOptionLiveTour ? 4 : enquiryType,
            recaptchaResult: token,
            parentFullName: parentDetail.parentFullName.trim(),
            parentFirstName: parentDetail.parentFirstName.trim(),
            parentLastName: parentDetail.parentLastName.trim(),
            email: parentDetail.email,
            contactNumber: parentDetail.contactNumber,
            bestTimeToCall: "Anytime",
            enquiryDetails: childDetail.comments,
            centreUserIdHash: props.isPickOptionLiveTour
                ? props.data.enquiryCentreDetailsList[0]?.centreUserIdHash
                : centreUserIdHash,
            saveDetails: false,
            additionalQuestions: additionalQuestionsPayload,
            childrenDetails: updatedChildrenDetails,
            hasVisitedBrandedHub: hasVisitedBrandedHub,
            suburb: parentDetail.suburb.key,
            ...Object.fromEntries(
                Object.entries(utmMap)
                    .filter(([utmKey]) => utms[utmKey])
                    .map(([utmKey, payloadKey]) => [payloadKey, utms[utmKey]])
            ),
            ...(props.isPickOptionLiveTour && {
                selectedVisitDays: [],
                liveTourBookingSlot: chooseTime.slot,
                token: props.data.token,
                includeRecommendCentresHtml: true,
                includeUpsellCentresHtml: true,
                centrePostcode: props.data.enquiryCentreDetailsList[0]?.centrePostcode,
                centreSuburbHashId:
                    props.data.enquiryCentreDetailsList[0]?.centreSuburbIdHash,
            }),
        };
    };

    function showTooltip() {
        const tooltip = document.getElementById("tooltip");
        tooltip.classList.toggle("hidden");
    }

    return (
        <div className="text-[#3A3A3A] pb-24 lg:pb-0">
            <h2 className="font-semibold md:text-[20px] text-[22px] mb-4 md:mb-6 text-[#3A3A3A]">
                Review your enquiry
            </h2>
            <div className="space-y-4 mb-6">
                <h3 className="font-semibold text-[16px] text-[#3A3A3A]">
                    Your details
                </h3>
                <div className="space-y-2 text-base font-normal">
                    <div className="flex flex-col gap-y-2 gap-x-6">
                        <div className="flex items-center md:gap-x-2">
                            <p className="min-w-[120px] md:min-w-[0px]">Name</p>
                            <p className="font-medium">{parentDetail.parentFullName}</p>
                        </div>
                        <div className="relative flex items-center md:gap-x-2 ">
                            <p className="min-w-[120px] md:min-w-[0px]">Email</p>
                            {/*<p className='font-medium'>{parentDetail.email || "N/A"}</p>*/}
                            <div
                                className="overflow-hidden text-ellipsis font-medium whitespace-nowrap w-80 cursor-pointer"
                                onClick={showTooltip}
                            >
                                {parentDetail.email}
                                <div
                                    id="tooltip"
                                    className="absolute left-0 top-full hidden p-2 bg-black text-white rounded text-sm whitespace-normal w-max"
                                >
                                    {parentDetail.email}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-y-2 gap-x-6">
                        <div className="flex items-center md:gap-x-2">
                            <p className="min-w-[120px] md:min-w-[0px]">Phone</p>
                            <p className="font-medium">
                                {parentDetail.contactNumber || "N/A"}
                            </p>
                        </div>
                        <div className="flex items-center md:gap-x-2">
                            <p className="min-w-[120px] md:min-w-[0px]">Suburb</p>
                            <p className="font-medium">
                                {parentDetail?.suburb?.label || "N/A"}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="space-y-4 mb-6">
                <h3 className="font-semibold text-[16px] mb-4 text-[#3A3A3A]">
                    Your Child's details
                </h3>
                <div className="space-y-4 md:space-y-0 md:flex flex-wrap gap-6">
                    {props.enquiryDetail.childDetail.items.map((item, index) => (
                        <div
                            key={index}
                            className="border max-w-[353px] w-full space-y-4 border-solid border-[#D9D8DF] p-4 rounded-lg"
                        >
                            <h4 className="font-poppins font-semibold text-base text-[#3A3A3A]">
                                Child {index + 1}
                            </h4>
                            <div className="space-y-2 text-[#3A3A3A]">
                                <div className="flex items-center text-base font-normal">
                                    <p className="min-w-[100px]">Name</p>
                                    <p className="font-medium">{item.childName || "N/A"}</p>
                                </div>
                                <div className="flex items-center text-base font-normal">
                                    <p className="min-w-[100px]">Birthday</p>
                                    <p className="font-medium">
                                        {`${item.day}/${item.month}/${item.year}`}{" "}
                                        {`(${calculateAge(
                                            `${item.day}/${item.month}/${item.year}`
                                        )})`}
                                    </p>
                                </div>
                                <div className="flex items-center text-base font-normal">
                                    <p className="min-w-[100px]">Care days</p>
                                    <p className="font-medium">
                                        {item.careDays
                                            .map((item) => item.label)
                                            .sort((a, b) => careDays.indexOf(a) - careDays.indexOf(b))
                                            .join(", ")}
                                    </p>
                                </div>
                                <div className="flex items-center text-base font-normal">
                                    <p className="min-w-[100px]">Start date</p>
                                    <p className="font-medium">{item.startDate.label}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {props.isPickOptionLiveTour && (
                <div className={`${props.enquiryDetail.childDetail.comments ? 'mb-6' : ''} space-y-4`}>
                    <h3 className="font-semibold text-[16px] mb-4 text-[#3A3A3A]">
                        Booking details
                    </h3>
                    <div className="space-y-4 md:space-y-0 md:flex flex-wrap gap-6">
                        <div className="border max-w-[353px] w-full space-y-4 border-solid border-[#D9D8DF] p-4 rounded-lg">
                            <div className="space-y-6">
                                <div className="flex items-center text-base font-normal gap-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <g clipPath="url(#clip0_1453_7484)">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M6.1987 0.827811C5.89563 0.913131 5.65604 1.16885 5.59254 1.47483C5.57535 1.55758 5.56923 2.41251 5.57367 4.11679L5.5802 6.63639L5.64471 6.77405C6.00774 7.54865 7.13415 7.39282 7.27107 6.54908C7.28468 6.4651 7.29591 6.05902 7.29601 5.6467L7.2962 4.89699L10.9502 4.8907L14.6042 4.88439L14.7409 4.82031C14.9153 4.73856 15.0824 4.5715 15.1641 4.39709C15.2195 4.27901 15.2282 4.22933 15.2282 4.03239C15.2282 3.82733 15.221 3.79027 15.1572 3.6642C15.0664 3.48512 14.8735 3.3073 14.6992 3.24209C14.567 3.19263 14.5489 3.19239 10.9334 3.19239H7.30035L7.29114 2.33439C7.28226 1.50776 7.2799 1.4713 7.22691 1.33726C7.15642 1.15896 6.96219 0.956619 6.78258 0.874395C6.61527 0.797787 6.37381 0.778539 6.1987 0.827811ZM17.3505 0.825195C17.0976 0.893403 16.8716 1.09553 16.7701 1.34439L16.7162 1.47639L16.7093 3.92439C16.7047 5.56006 16.7108 6.42672 16.7278 6.53616C16.8031 7.02166 17.2185 7.33579 17.6991 7.27059C17.9734 7.23336 18.2321 7.03774 18.3557 6.77405L18.4202 6.63639L18.4276 5.76639L18.4349 4.89639H19.6412C20.9943 4.89639 21.0018 4.89718 21.212 5.06333C21.2932 5.12753 21.3546 5.20472 21.4056 5.30669L21.4802 5.45604V7.10823V8.76039H12.0002H2.5202V7.10823V5.45604L2.59484 5.30669C2.71827 5.05968 2.97824 4.89689 3.25057 4.8961C3.66615 4.8949 4.04098 4.55871 4.09326 4.14027C4.11123 3.99632 4.07211 3.77467 4.00561 3.64373C3.94246 3.51936 3.75097 3.33545 3.61066 3.26439C3.49964 3.20815 3.47036 3.20453 3.1442 3.20681C2.84086 3.20892 2.76915 3.21742 2.58538 3.27295C1.7181 3.53503 1.10974 4.15767 0.870223 5.02839L0.804199 5.26839V13.1884V21.1084L0.856399 21.3124C1.09182 22.2325 1.76804 22.9088 2.6882 23.1442L2.8922 23.1964H12.0002H21.1082L21.3122 23.1442C22.2324 22.9088 22.9086 22.2325 23.144 21.3124L23.1962 21.1084V13.1884V5.26839L23.1303 5.02839C22.892 4.16059 22.2886 3.54245 21.415 3.27118L21.2042 3.20573L19.8182 3.19779L18.4322 3.18987V2.38018C18.4322 1.5061 18.4191 1.38728 18.3031 1.20639C18.2395 1.10744 18.0967 0.967491 17.9948 0.904539C17.907 0.850179 17.6766 0.792003 17.5572 0.793995C17.5038 0.794907 17.4108 0.808947 17.3505 0.825195ZM2.52598 15.7264L2.5322 20.9884L2.58421 21.0844C2.6462 21.1988 2.81137 21.3617 2.9282 21.4238C3.00963 21.467 3.28602 21.4684 12.0002 21.4684C20.7144 21.4684 20.9908 21.467 21.0722 21.4238C21.189 21.3617 21.3542 21.1988 21.4162 21.0844L21.4682 20.9884L21.4744 15.7264L21.4806 10.4644H12.0002H2.51977L2.52598 15.7264Z"
                                                fill="#5A60EC"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1453_7484">
                                                <rect width="24" height="24" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                    <p className="text-[#3A3A3A] text-[14px] font-medium">
                                        {dayName} {moment(chooseTime.tourDate).format("MMM Do")}
                                    </p>
                                </div>
                                <div className="flex items-center text-base font-normal gap-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <g clipPath="url(#clip0_1453_7488)">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M11.2561 0.818692C9.33186 0.946972 7.45804 1.575 5.85609 2.6286C4.57811 3.46913 3.46941 4.57784 2.62888 5.85581C1.9473 6.89211 1.4091 8.12544 1.11834 9.31728C0.377823 12.3527 0.925719 15.5542 2.62888 18.1438C3.46806 19.4198 4.58013 20.5318 5.85609 21.371C6.89238 22.0526 8.12572 22.5908 9.31756 22.8816C12.3522 23.6219 15.5552 23.0737 18.1441 21.371C19.42 20.5318 20.5321 19.4198 21.3713 18.1438C22.0529 17.1075 22.5911 15.8742 22.8818 14.6823C23.5027 12.1373 23.2246 9.47501 22.0938 7.13981C21.5203 5.95556 20.8441 5.00352 19.9203 4.07964C18.6302 2.78962 17.1227 1.87304 15.3666 1.31093C14.0885 0.901828 12.6297 0.727156 11.2561 0.818692ZM11.2681 2.53479C8.38345 2.762 5.73179 4.31165 4.12223 6.71093C3.2927 7.94744 2.78457 9.30728 2.57644 10.8478C2.51332 11.315 2.51332 12.6847 2.57644 13.1518C2.72951 14.2848 3.00465 15.1974 3.49175 16.1878C3.97177 17.1639 4.52502 17.9368 5.29405 18.7058C6.06306 19.4749 6.83603 20.0281 7.81209 20.5081C8.80252 20.9953 9.71509 21.2704 10.8481 21.4235C11.3152 21.4866 12.6849 21.4866 13.1521 21.4235C14.2851 21.2704 15.1977 20.9953 16.1881 20.5081C17.1641 20.0281 17.9371 19.4749 18.7061 18.7058C19.4751 17.9368 20.0284 17.1639 20.5084 16.1878C20.9046 15.3822 21.1442 14.6788 21.3094 13.8358C21.4482 13.1278 21.4675 12.9032 21.4675 11.9998C21.4675 11.0964 21.4482 10.8719 21.3094 10.1638C21.1442 9.32086 20.9046 8.61744 20.5084 7.81181C20.0284 6.83576 19.4751 6.06279 18.7061 5.29378C17.9371 4.52475 17.1641 3.9715 16.1881 3.49148C15.2149 3.01287 14.3385 2.74474 13.2361 2.58836C12.9725 2.55096 12.7372 2.53904 12.1441 2.53301C11.7283 2.52881 11.3341 2.5296 11.2681 2.53479ZM11.7824 5.59911C11.4574 5.69127 11.2229 5.94675 11.1623 6.27497C11.1257 6.47295 11.1257 11.9587 11.1623 12.1567C11.1968 12.3435 11.2598 12.4619 11.3989 12.601C11.5414 12.7434 11.6613 12.8057 11.8585 12.8396C11.9644 12.8578 12.6561 12.8638 14.0881 12.8589C15.9867 12.8524 16.1729 12.8483 16.2673 12.8105C16.501 12.7168 16.7107 12.5056 16.7897 12.2844C16.8381 12.1489 16.8381 11.8507 16.7897 11.7152C16.7107 11.4939 16.5007 11.2825 16.2673 11.1893C16.174 11.1521 16.0064 11.1475 14.5141 11.141L12.8641 11.1339V8.77529C12.8641 7.18092 12.8556 6.37049 12.838 6.27423C12.7673 5.88792 12.4478 5.60412 12.055 5.57859C11.9605 5.57244 11.8461 5.58106 11.7824 5.59911Z"
                                                fill="#5A60EC"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1453_7488">
                                                <rect width="24" height="24" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                    <p className="text-[#3A3A3A] text-[14px] font-medium">
                                        {chooseTime.tourTime}
                                    </p>
                                </div>
                                <div className="flex items-center text-base font-normal gap-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M8.625 10.3154C8.625 11.2105 8.98058 12.069 9.61351 12.7019C10.2465 13.3349 11.1049 13.6904 12 13.6904C12.8951 13.6904 13.7535 13.3349 14.3865 12.7019C15.0194 12.069 15.375 11.2105 15.375 10.3154C15.375 9.42032 15.0194 8.56188 14.3865 7.92894C13.7535 7.29601 12.8951 6.94043 12 6.94043C11.1049 6.94043 10.2465 7.29601 9.61351 7.92894C8.98058 8.56188 8.625 9.42032 8.625 10.3154Z"
                                            stroke="#5A60EC"
                                            strokeWidth="1.71"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M20.0724 10.0362C20.0724 17.0902 13.8827 21.0467 12.3675 21.9119C12.2664 21.9696 12.1521 22 12.0358 22C11.9194 22 11.8051 21.9696 11.704 21.9119C10.1888 21.0458 4 17.0884 4 10.0362C4 7.90487 4.84667 5.86083 6.35375 4.35375C7.86083 2.84667 9.90487 2 12.0362 2C14.1675 2 16.2116 2.84667 17.7187 4.35375C19.2257 5.86083 20.0724 7.90487 20.0724 10.0362Z"
                                            stroke="#5A60EC"
                                            strokeWidth="1.71"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    <p className="text-[#3A3A3A] text-[14px] font-medium">
                                        {props.data.enquiryCentreDetailsList?.[0] &&
                                            `${props.data.enquiryCentreDetailsList[0].centreAddress}, ${props.data.enquiryCentreDetailsList[0].centreSuburb} ${props.data.enquiryCentreDetailsList[0].centreState} ${props.data.enquiryCentreDetailsList[0].centrePostcode}`}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {!props.isPickOptionLiveTour && (
                <div className={`${props.enquiryDetail.childDetail.comments ? 'mb-6' : ''} space-y-4`}>
                    <h3 className="font-semibold text-[16px] text-[#3A3A3A]">
                        Enquiry details
                    </h3>
                    <div className="flex flex-wrap gap-4 mb-6">
                        {props.enquiryDetail.startEnquiry.map((item, index) => (
                            <div
                                className="p-4 inline-block rounded-lg bg-[#F9F7F3]"
                                key={index}
                            >
                                <div className="flex items-center gap-2">
                                    <Icon icon={item.icon} className="text-berry text-1xl"></Icon>
                                    <p className="font-medium text-[14px]">{item.label}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {props.enquiryDetail.childDetail.comments && (
                <>
                    <h3 className="text-[#3A3A3A] font-semibold text-lg mb-4">
                        Additional information
                    </h3>
                    <p className={`font-medium text-base ${errorMessage ? 'mb-6':''}`}>
                        {props.enquiryDetail.childDetail.comments}
                    </p>
                </>
            )}

            {!!maximiseOptions.length && (
                <>
                    <h3 className="text-[#3A3A3A] font-semibold text-lg mb-4">
                        We'll send your enquiry to:
                    </h3>
                    <ul className="font-poppins font-medium text-base mb-8 ml-6">
                        <li className="list-disc text-[#3A3A3A]">
                            {props.initialCareName}
                        </li>
                        {maximiseOptions.map((item) => (
                            <li key={item.centreUserId} className="list-disc text-[#3A3A3A]">
                                {item.name}
                            </li>
                        ))}
                    </ul>
                </>
            )}
            <span className="text-sm text-red-500">{errorMessage}</span>
            <div className="fixed bottom-0 left-0 right-0 bg-white p-4 md:pt-10 border-t border-gray-200 flex justify-center z-10 lg:static lg:bg-transparent lg:border-0 lg:justify-center lg:ml-[-340px]">
                <Button
                    disabled={isLoading}
                    type="button"
                    customClass="w-full lg:w-fit gap-x-2 my-0 lg:md:mb-0 cta-submit"
                    onClick={() => handleSendEnquiry()}
                >
                    {isLoading ? (
                        <>
                            <span>
                                {!props.isPickOptionLiveTour
                                    ? "Sending Enquiry"
                                    : "Sending Request"}
                            </span>
                            <Icon icon="eos-icons:loading" width="24" height="24" />
                        </>
                    ) : (
                        "Submit"
                    )}
                </Button>
            </div>
        </div>
    );
}

export default Review;
